<template>
  <div>
    <group-migration-manager
      v-if="group.portal != '3' && isAdmin()"
      :group="group"
    ></group-migration-manager>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="black--text">
            <span v-if="!editMode">{{ group.description }}</span>
            <v-text-field
              v-model="group.description"
              hint="Nom du groupe lisibile, utilisé par l'outil de recherche. Le nom du groupe doit être unique."
              persistent-hint
              v-else
              @keydown.enter="updateGroupName()"
              @keydown.esc="editMode = false"
              :autofocus="editMode"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              v-if="isGrantedUser()"
              color="black"
              small
              icon
              @click="updateGroupName()"
            >
              <v-icon v-if="editMode">mdi-content-save</v-icon>
              <v-icon v-else>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              v-if="editMode"
              color="black"
              small
              icon
              @click="cancelUpdateGroupName()"
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>

            <v-btn
              v-if="isGrantedUser()"
              color="red"
              :disabled="group.nbClientPortals > 0"
              @click="openDeleteGroupDialog = true"
              icon
              :loading="loadingDeleteGroup"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <div class="text-body-1 black--text">
                  {{ group.nbActiveClientPortals }} /
                  {{ group.nbClientPortals }}
                </div>
                <div class="text-subtitle-2">Portails actifs</div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-body-1 black--text">
                  {{
                    group.nbInheritedClientPortals
                      ? group.nbInheritedClientPortals
                      : "N/A"
                  }}
                </div>
                <div class="text-subtitle-2">Héritages groupes</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="black--text"> Présentation </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <div class="text-body-1 black--text">
                  {{ group.portalName }}
                </div>
                <div class="text-subtitle-2">Modèle</div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-body-1 black--text">
                  {{ getPortalVersionFromId(group.portal) }}
                </div>
                <div class="text-subtitle-2">Version</div>
              </v-col>
              <v-col v-if="group.isBuiltin" cols="12" md="4">
                <div class="text-body-1 black--text">
                  {{ group.portalOptions.name }}
                </div>
                <div class="text-subtitle-2">Template</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <client-card :group="group"></client-card>
      </v-col>
    </v-row>
    <delete-dialog
      :open.sync="openDeleteGroupDialog"
      v-on:delete="triggerDeleteGroup"
    >
      <template #title>
        Suppression du groupe {{ group.description }}
      </template>
      Vous êtes sur le point de supprimer ce groupe. Voulez-vous continuer ?
    </delete-dialog>
  </div>
</template>
<script>
import { defineComponent, ref } from "@vue/composition-api";
import { useGroup } from "@/composables/group";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import ClientCard from "@/components/Group/ClientCard";
import GroupMigrationManager from "../../components/Group/GroupMigrationManager";
import { useRoles } from "@/composables/roles";

export default defineComponent({
  components: {
    GroupMigrationManager,
    DeleteDialog,
    ClientCard,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const { data, deleteGroup, updateGroup } = useGroup();
    const { isAdmin, isGrantedUser } = useRoles();

    /* Variables */
    const openDeleteGroupDialog = ref(false);
    const listGroupPortals = ref([]);
    const loadingDeleteGroup = ref(false);
    const editMode = ref(false);

    /* Computed */

    /* Méthodes */
    const triggerDeleteGroup = async function () {
      const idGroupToDelete = props.group.id;
      loadingDeleteGroup.value = true;
      await deleteGroup(idGroupToDelete);
      loadingDeleteGroup.value = false;
    };
    const getPortalVersionFromId = function (idPortal) {
      switch (idPortal) {
        case 0:
          return "V2";
        case 1:
          return "V3";
        case 2:
          return "V4";
        case 3:
          return "V5";
        default:
          return "";
      }
    };
    const updateGroupName = function () {
      if (editMode.value) {
        editMode.value = false;
        data.groupForm.description = props.group.description;
        updateGroup(props.group);
      } else {
        editMode.value = true;
      }
    };

    const cancelUpdateGroupName = () => {
      if (editMode.value) {
        editMode.value = false;
      }
    };

    return {
      openDeleteGroupDialog,
      triggerDeleteGroup,
      listGroupPortals,
      getPortalVersionFromId,
      loadingDeleteGroup,
      editMode,
      updateGroupName,
      cancelUpdateGroupName,
      isAdmin,
      isGrantedUser,
    };
  },
});
</script>
